import React from "react";
import { ThumbnailsBlock } from '../ThumbnailsBlock';

export const ExhibitionsBlock = ({ exhibitions, ...props }) => (
    <ThumbnailsBlock thumbnails={exhibitions} {...props} />
)